import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import controller from './controller.vue';
import emptyImage from '@/resource/images/empty-preview.png';
import nexted from './nested';
export default {
  i18n: require('../design_i18n'),
  components: {
    draggable: draggable,
    controller: controller,
    nexted: nexted
  },
  data: function data() {
    return {
      // 拖拽组件参数
      dragOptions: {
        group: "description",
        disabled: false,
        touchStartThreshold: 5,
        ghostClass: "sortable-ghost",
        dragClass: "sortable-drag",
        filter: ".controller-title, .controller-aside" // 不允许此元素拖拽
      },
      images: {
        emptyImage: emptyImage
      }
    };
  },
  mounted: function mounted() {},
  computed: _objectSpread({}, mapState({
    platform: function platform(state) {
      return state.design.platform;
    },
    components: function components(state) {
      return state.design.components;
    },
    scale: function scale(state) {
      var scale = state.design.scale;
      var num = parseInt(scale) / 100;
      return num;
    }
  })),
  methods: {
    /**
     * 开始拖拽
     */
    handle_drag_start: function handle_drag_start() {
      this.$store.state.design.preview_in_drag = true;
    },
    /**
     * 结束拖拽
     */
    handle_drag_end: function handle_drag_end() {
      this.$store.state.design.preview_in_drag = false;
    }
  }
};